export default __webpack_public_path__ + "static/media/moralisScene.d9927dd2.png";